// import { DetailSupportFormTestComponent } from "../../../components/SupportSystem/SupportForm/DetailSupportFormTestComponent";
import { EstimateAnnounce11FormComponent } from "../../../components/SupportSystem/SupportForm/current/EstimateAnnounce11FormComponent";
import { NavbarSupportSystem } from "../../../components/share/NavbarSupportSystem";
import { HeadTitle } from "../../../components/share/HeadTitle";
import { Footer } from "../../../components/share/Footer";


export function EstimateAnnounce11FormContainer () {
    const titleName = "ระบบการให้เงินช่วยเหลือหรืออุดหนุนกองทุนพัฒนาฝีมือแรงงาน";
    return(
        <div className="page-container bg-landing">
            <NavbarSupportSystem />
            <HeadTitle title={titleName} />
            <EstimateAnnounce11FormComponent />
            <Footer />
        </div>        
    )
    
}